import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import langmap from 'langmap';
import { SURROUND_AUDIO_SUFFIX } from '../../../../common/constants';
import { Text } from '../../common';
import {
  Header,
  Menu,
  MenuItem,
  BottomShadow,
} from './styles';
import { isoMapping } from '../../../../player/utils/isoMapping';
import { IS_SAFARI } from '../../../../player/utils/platform';

const isOptionSelected = (option, selectedOption) => {
  if (option && selectedOption) {
    return option.toLowerCase() === selectedOption.toLowerCase();
  }

  return false;
};

const getLanguage = (code) => {
  let langCode = code;
  let hasHoh = false;
  const langSuffix = '(allt tal)';

  if (code.endsWith(SURROUND_AUDIO_SUFFIX)) {
    langCode = code.replace(SURROUND_AUDIO_SUFFIX, '');
  }

  if (IS_SAFARI) {
    if (code.endsWith('hoh')) {
      langCode = code.replace('hoh', '').trim();
      hasHoh = true;
    }

    if (isoMapping.get(langCode)) {
      langCode = isoMapping.get(langCode);
    }
  }

  if (langmap[langCode]) {
    return hasHoh ? (`${langmap[langCode].nativeName} ${langSuffix}`) : langmap[langCode].nativeName;
  }

  return null;
};

const TextMapping = {
  off: 'playerSettings.off',
  auto: 'playerSettings.auto',
  high: 'playerSettings.high',
  medium: 'playerSettings.medium',
  low: 'playerSettings.low',
};

export default function Setting(props) {
  const {
    action,
    title,
    options,
    selectedOption,
  } = props;

  const menuRef = useRef();

  const renderItem = (option, i) => (
    <MenuItem
      selected={isOptionSelected(option, selectedOption)}
      key={i}
      onClick={() => action(option)}
    >
      {
        TextMapping[option]
          ? (<Text id={TextMapping[option]} />)
          : (getLanguage(option) || option)
      }
      {
        option.endsWith(SURROUND_AUDIO_SUFFIX) ? <>&nbsp;(5.1)</> : null
      }
    </MenuItem>
  );

  // Don't show options when user has no choice
  if (options.length < 2) {
    return null;
  }

  // show bottom shadow when there is overflow and scroll position is less than 1px from bottom
  const showBottomShadow = menuRef.current?.scrollHeight > menuRef.current?.clientHeight
    && menuRef.current?.scrollHeight - menuRef.current?.scrollTop - menuRef.current?.offsetHeight >= 1;

  return (
    <div>
      <Header>{title}</Header>
      <Menu ref={menuRef}>
        {options.map((option, i) => renderItem(option, i))}
        {showBottomShadow && (
          <BottomShadow />
        )}
      </Menu>
    </div>
  );
}

Setting.propTypes = {
  action: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedOption: PropTypes.string,
};
